import { CheckCircle2, ArrowLeft, ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { Reveal, ChapterTag } from "./Reveal";

export default function Investors() {
  const { t, dir } = useLang();
  const Arrow = dir === "rtl" ? ArrowLeft : ArrowRight;
  return (
    <section id="investors" data-testid="investors-section" className="relative py-24 md:py-32 bg-navy-800/40 border-y border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -top-4 -end-4 w-24 h-24 border-t-2 border-e-2 border-gold/50 rounded-tr-3xl" />
            <div className="absolute -bottom-4 -start-4 w-24 h-24 border-b-2 border-s-2 border-gold/50 rounded-bl-3xl" />
            <img
              src="https://images.unsplash.com/photo-1681505515542-3a6c4ef756c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxhcmFiJTIwbWFuJTIwbGFwdG9wfGVufDB8fHx8MTc4NjI5OTA5NXww&ixlib=rb-4.1.0&q=85"
              alt={t("investors_title")}
              className="relative rounded-3xl w-full max-h-[480px] object-cover saturate-[0.75] shadow-2xl shadow-navy-950"
            />
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-t from-navy-900/70 to-transparent" />
            <div className="absolute bottom-6 start-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold text-navy-900 text-sm font-bold" data-testid="investors-badge">
              <Sparkles size={14} />
              {t("investors_badge")}
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <ChapterTag num="02" label={t("ch_investors")} />
            <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight leading-snug">{t("investors_title")}</h2>
            <p className="mt-5 text-white/60 text-base md:text-lg leading-relaxed">{t("investors_sub")}</p>
          </Reveal>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {t("investors_points").map((p, i) => (
              <Reveal key={p} delay={i * 0.05}>
                <div className="flex items-start gap-3" data-testid={`investor-point-${i}`}>
                  <CheckCircle2 size={20} className="text-gold shrink-0 mt-0.5" />
                  <span className="text-sm md:text-base text-white/80">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-wrap items-center gap-5">
              <a href="#contact" data-testid="investors-cta"
                className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-gold text-navy-900 font-bold hover:bg-gold-light transition-colors duration-300 shadow-xl shadow-gold/20">
                {t("investors_cta")}
                <Arrow size={18} className="transition-transform duration-300 rtl:group-hover:-translate-x-1 ltr:group-hover:translate-x-1" />
              </a>
              <Link to="/services/foreign-company-formation" data-testid="investors-more-link"
                className="text-gold text-sm font-semibold underline-offset-4 hover:underline">
                {t("investors_more")}
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
